import React, { useMemo, useState } from 'react';
import { object, func } from 'prop-types';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { MessageModal, Modal, TableCustom } from '../../common';
import { getDateToString } from '../../../utils/convert';

const NotificacionSeleccionModal = (props) => {

    const [seleccion, setSeleccion] = useState([]);
    const [confirmacion, setConfirmacion] = useState('');

    const cuotas = useMemo(() => [...props.data.cuotas].sort((a, b) => a.cuota - b.cuota), [props.data.cuotas]);
    const notificacionDe = (idEmisionEjecucionCuota) => props.data.notificaciones.find(f => f.idEmisionEjecucionCuota === idEmisionEjecucionCuota);
    const todasSeleccionadas = cuotas.length > 0 && cuotas.every(f => seleccion.includes(f.id));

    // la fecha del último envío que la incluyó, y si ese envío no terminó: uno que falla a mitad ya mandó parte de los mails
    const getTextoNotificacion = (notificacion) => {
        if (!notificacion || !notificacion.fechaNotificacion) return '';
        const fecha = getDateToString(new Date(notificacion.fechaNotificacion), true);
        return (notificacion.notificacionFinalizada) ? fecha : `${fecha} (el envío no terminó)`;
    }

    // la selección de filas de la app (Deuda, condonación): la casilla de la fila sólo muestra el estado y el clic en
    // cualquier parte de la fila la marca o la desmarca
    const cellSelAll = (cell) =>    <div className='action-check'>
                                        <input name="selectedAll" type="checkbox" value={''} className='form-check-input' title="Seleccionar todas"
                                            checked={ todasSeleccionadas }
                                            onChange={({target}) => handleClickTodas(target.checked)}
                                        />
                                    </div>

    const cellSel = (cell) =>       <div className='action-check'>
                                        <input className='form-check-input' type="checkbox" value={''} checked={ seleccion.includes(cell.value) } readOnly={true} />
                                    </div>

    const tableColumns = [
        { Header: cellSelAll, Cell: cellSel, accessor: 'id', width: '3%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false },
        { Header: 'Cuota', Cell: (cell) => `${props.data.periodo} / ${cell.row.original.cuota} - ${cell.row.original.descripcion}`, accessor: 'cuota', width: '45%', disableSortBy: true },
        { Header: 'Vencimiento', Cell: (cell) => getDateToString(cell.value), accessor: 'fechaVencimiento1', width: '17%', disableSortBy: true, ellipsis: false },
        { Header: 'Notificada', Cell: (cell) => getTextoNotificacion(notificacionDe(cell.value)) || 'No', id: 'notificada', accessor: 'id', width: '35%', disableSortBy: true }
    ];

    //handles
    const handleClickCuota = (idEmisionEjecucionCuota) => {
        setSeleccion(prevState => prevState.includes(idEmisionEjecucionCuota) ?
            prevState.filter(f => f !== idEmisionEjecucionCuota) :
            [...prevState, idEmisionEjecucionCuota]);
    }

    const handleClickTodas = (checked) => {
        setSeleccion(checked ? cuotas.map(x => x.id) : []);
    }

    const handleClickAceptar = () => {
        if (seleccion.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar al menos una cuota');
            return;
        }

        const notificadas = cuotas.filter(f => seleccion.includes(f.id) && getTextoNotificacion(notificacionDe(f.id)).length > 0);
        if (notificadas.length === 1) {
            setConfirmacion(`La cuota ${notificadas[0].cuota} ya se notificó el ${getTextoNotificacion(notificacionDe(notificadas[0].id))}. ¿Desea notificarla otra vez?`);
        }
        else if (notificadas.length > 1) {
            const detalles = notificadas.map(f => `la cuota ${f.cuota} el ${getTextoNotificacion(notificacionDe(f.id))}`);
            setConfirmacion(`Ya se notificó ${detalles.slice(0, -1).join(', ')} y ${detalles[detalles.length - 1]}. ¿Desea notificarlas otra vez?`);
        }
        else {
            handleConfirm();
        }
    }

    const handleConfirm = () => {
        props.onConfirm(cuotas.filter(f => seleccion.includes(f.id)).map(x => x.id));
    }

    const handleClickCancelar = () => {
        props.onDismiss();
    }


    return (
        <>

        {/* el foco va a «Aceptar»: con el foco en «Seleccionar todas», el primer control, la grilla la pinta del color de una casilla tildada */}
        <Modal
            size="lg"
            title="Cuotas a notificar"
            focusPrimary
            onEscape={handleClickCancelar}
            body={(
                <div className="row form-basic">
                    <div className="col-12">
                        <p>Elija las cuotas que informa el aviso.</p>
                        <TableCustom
                            showFilterGlobal={false}
                            showDownloadCSV={false}
                            pageSize={cuotas.length}
                            className={'TableCustomBase'}
                            columns={tableColumns}
                            data={cuotas}
                            onClickRow={(row) => handleClickCuota(row.original.id)}
                        />
                    </div>
                </div>
            )}
            footer={(<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
            </>)}
        />

        {confirmacion.length > 0 &&
            <MessageModal
                title="Confirmación"
                message={confirmacion}
                onDismiss={() => setConfirmacion('')}
                onConfirm={() => {
                    setConfirmacion('');
                    handleConfirm();
                }}
            />
        }

        </>
    );
}

NotificacionSeleccionModal.propTypes = {
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

export default NotificacionSeleccionModal;
